"use strict";
/**
 * Stopgap for checking of function args with TypeScript
 * Remove when TypeScript 2.0 is released.
 */
function isFunction(object) {
    return (typeof object === "function");
}
/**
 * Turns HTML-sensitive characters into HTML entities
 * Escapes all of &><"'`
 */
function escapeHTML(str) {
    if (typeof str !== "string" || str.length === 0) {
        return "";
    }
    return str.replace(/&/g, '&amp;')
        .replace(/>/g, '&gt;')
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/`/g, '&#96;');
}
exports.escapeHTML = escapeHTML;
/**
 * An HTML snippet that's escaped by default.
 * Embedded instances of $html will not be extra-escaped.
 * Use $${"data"} to skip escaping of an input.
 */
function $html(literalSections) {
    var substs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        substs[_i - 1] = arguments[_i];
    }
    var raw = literalSections.raw;
    var result = "";
    substs.forEach(function (subst, i) {
        var lit = raw[i];
        if (Array.isArray(subst)) {
            subst = subst.join("");
        }
        if (lit.endsWith("$")) {
            lit = lit.slice(0, -1);
        }
        else {
            if (subst == null) {
                subst = "null";
            }
            else if (subst.safeInHTML) {
                subst = subst.toString();
            }
            else {
                subst = escapeHTML(subst.toString());
            }
        }
        result += lit;
        result += subst;
    });
    result += raw[raw.length - 1];
    return {
        toString: function () {
            return result;
        },
        safeInHTML: true
    };
}
exports.$html = $html;
/**
 * Executes the given string or function a given number of times.
 */
function $times(count, method) {
    var buffer = [];
    for (var i = 0; i < count; i += 1) {
        if (isFunction(method)) {
            buffer.push(method(i));
        }
        else {
            buffer.push(method);
        }
    }
    return $join(buffer);
}
exports.$times = $times;
/**
 * Maps a list of values using the given function or string.
 */
function $map(collection, method) {
    var buffer = [];
    var len = collection.length;
    for (var i = 0; i < len; i++) {
        if (isFunction(method)) {
            buffer.push(method(collection[i], i));
        }
        else {
            buffer.push(method);
        }
    }
    return buffer;
}
exports.$map = $map;
/**
 * Maps all values of the collection using $map, then joins the array.
 * Use `$map` to get an array.
 */
function $each(collection, method) {
    var values = $map(collection, method);
    return $join(values);
}
exports.$each = $each;
/**
 * Joins together a list of values and attempts to preserve safeInHTML if all values are.
 */
function $join(collection) {
    var isMixed = false;
    var isSafe;
    for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
        var value = collection_1[_i];
        var valueSafe = (value != null) && value["safeInHTML"];
        if (isSafe == null) {
            isSafe = valueSafe;
        }
        else {
            if (isSafe !== valueSafe) {
                isMixed = true;
            }
            isSafe = isSafe && valueSafe;
        }
    }
    var str = collection.join("");
    if (isMixed) {
        console.error("Mixed safe/unsafe content found in an ekma loop. This should be avoided as of ekma 0.3.0!");
    }
    if (isSafe) {
        return {
            toString: function () {
                return str;
            },
            safeInHTML: true
        };
    }
    else {
        return str;
    }
}
exports.$join = $join;
/**
 * Calls the given function with the given object as a parameter.
 * Useful for aliasing a value to a shorter name in a template.
 */
function $alias(object, method) {
    return method(object);
}
exports.$alias = $alias;
/**
 * Executes the function or string only if the condition given is truthy.
 */
function $if(condition, method, other) {
    if (condition) {
        if (isFunction(method)) {
            return method();
        }
        else if (method) {
            return method;
        }
    }
    else {
        if (isFunction(other)) {
            return other();
        }
        else if (other) {
            return other;
        }
    }
    return "";
}
exports.$if = $if;

//# sourceMappingURL=index.js.map
